import _ from 'lodash';

import {
  GS_SALES_GROUPS_CLASSIFY_REQUEST,
  GS_SALES_GROUPS_CLASSIFY_SUCCESS,
  GS_SALES_GROUPS_CLASSIFY_FAILURE
  
} from './actions';

import createReducer from 'state/createReducer';

const initialState = {
  updateClassificationRequest: false,
  startDate: null,
  endDate: null,
  list: [],  
};

const handlers = {
  [GS_SALES_GROUPS_CLASSIFY_REQUEST](state, payload) {
    return {
      ...state,
      updateClassificationRequest: true
    };
  },

  [GS_SALES_GROUPS_CLASSIFY_SUCCESS](state, payload) {    
    return {
      ...state,
      updateClassificationRequest: false,
      list: _.get(payload, 'list', []),
      startDate: _.get(payload, 'sd', null),
      endDate: _.get(payload, 'ed', null)
    };
  },

  [GS_SALES_GROUPS_CLASSIFY_FAILURE](state, payload) {
    return {
      ...state,
      updateClassificationRequest: false
    };
  }
};

export default (state = initialState, action) => createReducer(state, action, handlers);
